import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { AuthGate } from "@/components/auth-gate";

/**
 * `_app` segment — wraps every authenticated view (/ihub, /askme,
 * /library, /settings). AuthGate checks the session up front:
 *   - Loading → centered loader
 *   - No session → navigate to "/"
 *   - Session → render the shared shell + the matched child route
 *
 * The SSE stream is opened inside AuthGate so it persists across
 * client-side navigations between the child routes.
 */
export const Route = createFileRoute("/_app")({
  component: () => (
    <AuthGate>
      <AppShell>
        <Outlet />
      </AppShell>
    </AuthGate>
  ),
});
